import React from "react";
import { useTranslation } from "react-i18next";

import css from "./no_permissions.module.scss";

const NoPermissions = () => {
  const { t } = useTranslation("bookingModule");
  return <span className={css.noPermissions}>{t("approvals.noPermissions")}</span>;
};

export default NoPermissions;
